"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForegroundFadeInBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_fela_1 = require("react-fela");
const fi_1 = require("react-icons/fi");
const VibescoutZIndexes_1 = require("../../../styling/VibescoutZIndexes");
const FullAbsDiv_1 = require("../common/FullAbsDiv");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaCommon_1 = require("../fela/FelaCommon");
const FelaFlexbox_1 = require("../fela/FelaFlexbox");
const FelaIconWrap_1 = require("../fela/FelaIconWrap");
const FelaLayers_1 = require("../fela/FelaLayers");
const FelaText_1 = require("../fela/FelaText");
const ForegroundFadeInBox = ({ children, show, zIndex = VibescoutZIndexes_1.ZIndexes.foregroundFadeBox, fadeTimeout = 250, showHeader = false, header, title, onClose, position = "fixed", pushMaxWidth, }) => {
    const { theme } = (0, react_fela_1.useFela)();
    const [lingeringShow, setLingeringShow] = (0, react_1.useState)(false);
    const timeoutRef = (0, react_1.useRef)();
    const unmountedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        unmountedRef.current = false;
        if (show) {
            clearTimeout(timeoutRef.current);
            setLingeringShow(true);
            // openPortal();
        }
        else {
            timeoutRef.current = setTimeout(() => {
                if (!unmountedRef.current) {
                    setLingeringShow(false);
                }
                // closePortal();
            }, fadeTimeout);
        }
        return () => {
            unmountedRef.current = true;
        };
    }, [show]);
    const shadowRgbColorString = theme.dark
        ? theme.styles.Colors.darkFore.dar[0]
        : theme.styles.Colors.darkBack.shadow[0];
    // const child = useMemo(() => children, []);
    // const child = children;
    // const shadowRgbColorString = theme.dark ? theme.styles.Colors.lightBack.shadow[0] : theme.styles.Colors.darkBack.shadow[0];
    // const shadowRgbColorString = theme.styles.Colors.darkBack.shadow[0];
    return ((0, jsx_runtime_1.jsx)(FullAbsDiv_1.FullAbsDiv, { style: { pointerEvents: "none" }, children: (0, jsx_runtime_1.jsx)(FelaFlexbox_1.FelaFlexbox, { align: "center", justify: "center", style: {
                zIndex,
                opacity: show ? 1 : 0,
                position,
                top: 0,
                left: 0,
                transition: `background ${fadeTimeout}ms ease-in-out, backdrop-filter ${fadeTimeout}ms ease-in-out, opacity ${fadeTimeout}ms ease-in-out`,
                background: `rgba(${shadowRgbColorString}, ${show ? `0.65` : `0`})`,
                width: "100%",
                height: "100%",
                backdropFilter: "blur(2px)",
                overflow: "hidden",
                pointerEvents: "none",
            }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                    maxHeight: "calc(100%)",
                    boxShadow: `0 0 1.5em 0.5em rgba(${shadowRgbColorString}, 0.7)`,
                    overflow: "auto",
                    transition: `transform ${fadeTimeout + 100}ms ease-in-out`,
                    transform: `translateY(${show ? 0 : 35}%)`,
                    pointerEvents: "all",
                    width: pushMaxWidth ? pushMaxWidth : undefined,
                    maxWidth: pushMaxWidth ? "100%" : undefined,
                }, children: [(showHeader || header != null) && lingeringShow && ((0, jsx_runtime_1.jsxs)(FelaLayers_1.FelaHeaderBar, { top: 0, sticky: true, zIndex: VibescoutZIndexes_1.ZIndexes.higherBar, justify: "space-between", gap: 0.5, children: [(0, jsx_runtime_1.jsx)(FelaFlexbox_1.FelaFlexbox, { padding: "0.5em", grow: 1, align: "center", children: title ? ((0, jsx_runtime_1.jsx)(FelaText_1.FelaText, { spacing: "0.08em", transform: "uppercase", neutralColor: VibescoutFrontendStyleConfig_1.EAppColor.primary, weight: VibescoutFrontendStyleConfig_1.ETextWeightType.bold, size: VibescoutFrontendStyleConfig_1.ETextSize.content, children: title })) : (header) }), (0, jsx_runtime_1.jsx)(FelaIconWrap_1.FelaIconWrap, { contrast: FelaCommon_1.EGraphicContrast.HIGH, isButton: true, hoverable: true, onClick: onClose, children: (0, jsx_runtime_1.jsx)(fi_1.FiX, {}) })] })), show || lingeringShow ? children : null] }) }) }));
};
exports.ForegroundFadeInBox = ForegroundFadeInBox;
